<div [ngBusy]="{busy: fetchSubscription, message: 'Loading Results ...'}"></div>
<div [ngBusy]="{busy: rescoreSubscription, message: 'Scoring Policy ...'}"></div>
<div *ngIf="this.outputJson !== undefined" class="card" style="padding: 20px; height: 100%">
  <div class="row" style="height: calc(50% - 32px)">
    <div class="col-md-3">
      <div class="card">
        <h5 class="card-header text-white card-custom">
          {{this.outputJson.input.InsuredName}}
        </h5>

        <table class="table table-sm">
          <tbody>
            <tr>
              <th scope="row">Submission Date</th>
              <td>{{this.outputJson.submission.date}} ({{this.outputJson.submission.number}})</td>
            </tr>
            <tr>
              <th scope="row">Tax ID</th>
              <td>{{this.outputJson.input.InsuredTaxID}}</td>
            </tr>
            <tr>
              <th scope="row">Policy Year</th>
              <td>{{this.outputJson.input.PolicyYear}}</td>
            </tr>
            <tr>
              <th scope="row">Effective Date</th>
              <td>{{this.outputJson.input.EffectiveDate}}</td>
            </tr>
            <tr>
              <th scope="row">Expiration Date</th>
              <td>{{this.outputJson.input.ExpirationDate}}</td>
            </tr>
            <tr>
              <th scope="row">Rating State</th>
              <td>{{this.outputJson.input.RatingState}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="!validated" class="col-md-6">
      <div class="card">
        <h5 class="card-header text-white card-custom">
          Errors/Warnings
        </h5>
        <table *ngIf="validationErrors" class="table">
          <thead class="thead-light">
            <tr>
              <th>Errors</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let err of validationErrors">
             {{err}}
            </tr>
          </tbody>
        </table>
        <table *ngIf="validationWarnings"  class="table">
          <thead class="thead-light">
            <tr>
              <th>Warnings</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let warn of validationWarnings">
             {{warn}}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="validated" class="col-md-3">
      <div class="card">
        <h5 class="card-header text-white card-custom">
          Gradient Predictions
        </h5>

        <table class="table table-sm">
          <tbody>
            <tr>
              <th scope="row">Gradient Rank (1-{{maxRank}})</th>
              <td>{{this.outputJson.output.UWPredictionResults.GradientRank}}</td>
            </tr>
            <tr *ngIf="(isAdmin | async) || (displayType=='default_view' && (hasLossHistory || newVenture))">
              <th scope="row">Predicted Loss ($)</th>
              <td>{{this.outputJson.output.UWPredictionResults.PredictedLoss | currency}}</td>
            </tr>
            <tr *ngIf="isAdmin | async">
              <th scope="row">High Range Premium</th>
              <td>{{this.outputJson.output.UWPredictionResults.HighRangePremium | currency}}</td>
            </tr>
            <tr *ngIf="(isAdmin | async) || (displayType=='target_premium_view' && (hasLossHistory || newVenture))">
              <th scope="row">Target Premium</th>
              <td>{{this.outputJson.output.UWPredictionResults.TargetPremium | currency}}</td>
            </tr>
            <tr *ngIf="isAdmin | async">
              <th scope="row">Low Range Premium</th>
              <td>{{this.outputJson.output.UWPredictionResults.LowRangePremium | currency}}</td>
            </tr>
            <tr *ngIf="isAdmin | async">
              <th scope="row">Target Factor</th>
              <td>{{this.outputJson.output.UWPredictionResults.TargetFactor}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="validated" class="col-md-3">
      <div class="card">
        <h5 class="card-header text-white card-custom">
          Important Model Inputs
        </h5>

        <table *ngIf="hasLossHistory || newVenture || (isAdmin | async)" class="table table-sm">
          <tbody *ngIf="isAdmin | async">
            <tr *ngFor="let driver of this.outputJson.output.UWPredictionResults.TopPredictionInputs | keyvalue"
                [ngClass]="(driver.value <= 0) ? 'table-success':'table-danger'">
              <td>{{driver.key}} ({{driver.value}})</td>
            </tr>
          </tbody>
          <tbody *ngIf="!(isAdmin | async)">
            <tr *ngFor="let driver of this.outputJson.output.UWPredictionResults.TopPredictionInputs | keyvalue">
              <td>{{driver.key}}</td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!hasLossHistory && !newVenture && !(isAdmin | async)" class="card-body">
          No Risk Drivers Available
        </div>
      </div>
    </div>
    <div class="col-md-3 h100">
      <div class="card h100">
        <h5 class="card-header text-white card-custom">
          Score History
        </h5>
        <ag-grid-angular
            id="submissionhistorygrid"
            class="ag-theme-alpine grid-size"
            [columnDefs]="submissionColumnDefs"
            [rowData]="submissionHistoryRowDataSubject$.asObservable() | async"
            [defaultColDef]="defaultColumDefs"
            [overlayNoRowsTemplate]="overlayNoScoresTemplate"
            (firstDataRendered)="onFirstDataRendered($event)"
            (gridReady)="onSubmissionHistoryGridReady($event)"
            (rowClicked)="onRowClicked($event)"
            (rowDoubleClicked)="onRowClicked($event)"
            [frameworkComponents]="frameworkComponents"
            [modules]="modules">
        </ag-grid-angular>
      </div>
    </div>

  </div>
  <div class="row" style="height: calc(50% - 32px)">
    <div class="col-md-6 h100">
      <div class="card h100">
        <h5 class="card-header text-white card-custom">
          Class Code Breakdown
        </h5>
        <ag-grid-angular
          class="ag-theme-alpine grid-size"
          [columnDefs]="unitColumnDefs"
          [rowData]="classCodeRowDataSubject$.asObservable() | async"
          [defaultColDef]="defaultColumDefs"
          (gridReady)="onClassCodeGridReady($event)"
          [frameworkComponents]="frameworkComponents"
          (firstDataRendered)="onFirstDataRendered($event)"
          [modules]="modules">
        </ag-grid-angular>
      </div>
    </div>
    <div class="col-md-6 h100">
      <div class="card h100">
        <h5 class="card-header text-white card-custom">
          Loss History
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="inlineCheckbox1"
                   [checked]="showLossHistory" [disabled]="!validated"
                   (click)="onLossHistoryClicked($event)"
                   (change)="showLossHistory = !showLossHistory">
          </div>
          <label *ngIf="showLossHistory" style="font-size: small">(Double Click Cell to edit)</label>
          <div *ngIf="showLossHistory" class="btn-group float-right btn-group-sm" role="group">
            <button  class="btn btn-theme btn-light btn-xs"
                     ngbTooltip="Add Loss History Row"
                     (click)="AddLossHistoryRow($event)"
                     [disabled]="!validated"
                     type="button">Add</button>
<!--            <fa-icon class="fa-lg" [icon]="['fas', 'plus-square']"></fa-icon>-->
            <button *ngIf="showLossHistory" class="btn btn-theme btn-light btn-xs"
                     ngbTooltip="DeleteSelected Loss History Row"
                     (click)="RemoveLossHistoryRow($event)"
                     [disabled]="!validated || !selected"
                     type="button">Del</button>
<!--<fa-icon class="fa-lg" [icon]="['fas', 'minus-square']"></fa-icon>            -->
          </div>
        </h5>
        <div *ngIf="!(showLossHistory)" class="card-body">
          Loss History is unknown or has not been provided
        </div>

        <ag-grid-angular *ngIf="showLossHistory"
            class="ag-theme-alpine grid-size"
            [columnDefs]="lossHistoryColumnDefs"
            [defaultColDef]="defaultColumDefs"
            [rowData]="lossHistoryRowDataSubject$.asObservable() | async"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate"
            (firstDataRendered)="onFirstDataRendered($event)"
            rowSelection="single"
            rowDeselection="true"
            (gridReady)="onLossHistoryGridReady($event)"
            (selectionChanged)="onRowSelected($event)"
            [enableCellChangeFlash]="true"
            [components]="components"
            [modules]="modules">
        </ag-grid-angular>
      </div>
    </div>
  </div>
  <div class="card-footer">
          <button class="btn btn-theme btn-warning float-right" type="button"
                  (click)="reloadData()"
                  [disabled]="!isDirty()"
                  data-toggle="tooltip" data-placement="top" title="Revert any Changes">Discard Changes</button>
          <button class="btn btn-theme btn-primary float-right mr-2" type="button"
                  (click)="rescorePolicy()"
                  [disabled]="!isDirty()"
                  data-toggle="tooltip" data-placement="top"
                  title="Rescore Policy"> {{ scoreAsNewVenture() == true ? 'Score New Venture' : 'Score Policy' }}</button>

  </div>
<!--  <pre *ngIf="isAdmin | async">-->
<!--  <code>{{ outputJson | json }}</code>-->
<!--  </pre>-->
</div>
